import axios from "axios";
import BASEURL from "../config/api";
import Cookies from "universal-cookie";
import CONSTANTS from "./constant";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

// toast.configure();

// const cookies = new Cookies();
// const loginData = cookies.get('loginData');
// console.log('loginData', loginData?.token);
// const token = loginData?.token || '';
/**
 * Common API method
 * @param {string} method GET | POST | DELETE | PATCH
 * @param {string} baseURL http://api.example.com
 * @param {string} url /user/id
 * @param {object} params Query parameters
 * @param {object} headers API headers are appended to common headers
 * @param {object} body API body / Empty by default
 */

const AXIOSCALL = async (
  method,
  url,
  params = {},
  headers = {},
  body = {},
  baseURL = BASEURL.url
) => {
  //const navigate = useNavigate();

  try {
    const cookies = new Cookies();

    const loginData = cookies.get("loginData");

    // const  loginResponse  = useSelector((state) => {
    //   return state.login;
    // });
    // console.log("loginresponse>>>>>>>>>>>>>>>>", loginResponse);
    let auth_token = loginData?.token;
    // console.log("auth_token?.token--------------->>>", auth_token);
    const commonHeaders = {
      //     email: localStorage.getItem('EMAIL_ID'),
      //     userId: localStorage.getItem('USER_ID'),
      // 'Access-Control-Allow-Origin': '*',
      Authorization: auth_token,
      //     userTokenUniqueId: localStorage.getItem('USER_TOKEN_ID'),
      //     deviceId: localStorage.getItem('DEVICEID'),
      //     deviceName: localStorage.getItem('DEVICENAME'),
      //     deviceModel: localStorage.getItem('DEVICEMODEL'),
      //     os: localStorage.getItem('OS'),
      //     osVersion: localStorage.getItem('OSVERSION'),
      //     browserVersion: localStorage.getItem('BROWSERVERSION'),
      //     id: localStorage.getItem('USER_ID'),
    };

    console.log("commonHeaders------------->>", commonHeaders);

    const response = await axios({
      method,
      // baseURL,
      url,
      params: { ...params },
      headers: { ...commonHeaders, ...headers },
      data: body,
    });
    console.log("Response", response?.data?.data);

    return {
      status: response.status,
      message: response.data.message,
      data: response.data,
    };
  } catch (error) {
    console.log("errorsss:::::", error.toJSON());
    let errorCode = error.toJSON()?.status;
    let feedbackURL = error.toJSON()?.config?.url;
    if (errorCode === null) {
      //navigate('/');
      window.location.href = "/";
      toast.error("Network Failed!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "network_failed",
      });
    }
    if (errorCode === CONSTANTS.STATUS.UNAUTHORIZED) {
      //navigate('/');
      window.location.href = "/";
      toast.error("Unauthorized Access..!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "unauthorized_access",
      });
    }
    if (errorCode == CONSTANTS.STATUS.INTERNAL_SERVER_ERROR) {
      toast.error("Internal Server Error...!!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "internal_server_error",
      });
    } else if (
      errorCode === CONSTANTS.STATUS.FORBIDDEN ||
      errorCode === CONSTANTS.STATUS.UNAUTHORIZED
    ) {
      //navigate('/');
      window.location.href = "/";
      toast.error("Unauthorized Access..!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "unauth",
      });
    } else if (errorCode == "failed") {
      window.location.href = "/";
      toast.error("Api server is down..!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "server_down",
      });
    } else if (errorCode == CONSTANTS.STATUS.NOT_APPLICABLE) {
      toast.error("This record cannot be deleted..!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "delete",
      });
    } else if (errorCode == CONSTANTS.STATUS.BAD_REQUEST) {
      toast.error("Bad Request..!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "bad_request",
      });
    } else if (errorCode === null) {
      //navigate('/');
      window.location.href = "/";
      toast.error("Api server is down..!!", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "server_down1",
      });
    } else if (errorCode == CONSTANTS.STATUS.REQUEST_FAILED) {
    } else if (errorCode == CONSTANTS.STATUS.DUPLICATE_RECORD) {
      // toast.error('Some error Occurred', {
      // 	position: 'bottom-right',
      // 	autoClose: 3000,
      // 	hideProgressBar: true,
      // 	closeOnClick: true,
      // 	pauseOnHover: true,
      // 	draggable: true,
      // 	progress: undefined,
      // });
    } else if (errorCode == CONSTANTS.STATUS.DATA_NOT_FOUND) {
      if (
        feedbackURL !==
        "https://45nqltb6r4.execute-api.ap-south-1.amazonaws.com/dev/api/v1/view-feedback-response"
      ) {
        toast.error("No Data Found", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
          toastId: "no_data",
        });
      }
    } else {
      toast.error("Some error Occurred", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
        toastId: "err_occur",
      });
    }

    return {
      data: error,
      err: error.response,
      message: error.response !== undefined ? error.response.statusText : "",
      status: error.response !== undefined ? error.response.status : "failed",
    };
  }
};

export default AXIOSCALL;
